module.exports = __webpack_public_path__ + "static/img/build_plan_icon.4c349574.svg";